/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../store";
import { UserState } from "../redux/reducer";
import Error from "../../../shared/components/Error";
import { fetchCustomUserAction } from "../redux/actions";
import UnAuthorized from "../../../shared/components/UnAuthorized";
import { LoginState } from "../../login/redux/reducer";

export default function Messages(props: { match: any }): JSX.Element {
  const history = useHistory();
  const dispatch = useDispatch();
  const { match } = props;
  const userUrl = match.params.id;
  const { fetchCustomUserIsLoading, customUser: currentUser } = useSelector<AppState, UserState>(
    (state) => state.userManagement
  );
  const { authenticationUID } = useSelector<AppState, LoginState>((state) => state.loginManagement);

  useEffect(() => {
    if (userUrl && userUrl !== currentUser?.url) {
      dispatch(fetchCustomUserAction(userUrl));
    }
  }, [currentUser, dispatch, userUrl]);

  if (fetchCustomUserIsLoading) {
    return <div style={{ height: "100vh" }} />;
  }
  if (currentUser === undefined) {
    return <Error />;
  }
  if (authenticationUID === undefined || authenticationUID !== currentUser.uid) {
    return <UnAuthorized />;
  }

  return (
    <>
      <Helmet>
        <title>Messages - Aduwata.lk</title>
        <meta name="description" content="ඕනිම දෙයක් විකුණන්න මිලදී ගන්න හොඳම තැන - Aduwata.lk" />
      </Helmet>
      <section className="dashboard-part">
        <div className="container">
          <div className="row">
            <div className="col-lg-12" style={{ height: "100vh" }}>
              Coming Soon...
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
